import { FieldViewModel, ICropping } from "../omnia";
import { MergeCtrl } from "./merge";

export class MergedCropViewModel {

    area: number;

    constructor(private ctrl: MergeCtrl, public crop: FieldViewModel, private _selected: boolean = false) {
    }

    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {
        this.setSelected(value, true);
    }

    get canSelect(): boolean {
        return !!this.crop;
    }

    setSelected(selected: boolean, notify: boolean) {
        selected = selected && this.canSelect;
        this._selected = selected;
        if (!selected && this.retain) this.retain = false;
        if (notify) this.ctrl.updateMapSelection();
    }

    get croppingId(): number {
        return this.crop.croppingId;
    }

    get cropping(): ICropping {
        return this.crop.cropping;
    }

    hasBoundary(): boolean {
        return this.crop.hasBoundary();
    }

    getBoundary(): any {
        return this.crop.getBoundary();
    }

    getDescription(): string {
        return this.crop.getDescription();
    }

    get retain(): boolean {
        return (this.ctrl.retainedCrop == this);
    }

    set retain(value: boolean) {
        this.ctrl.retainedCrop = ((!value) || (this.ctrl.retainedCrop == this) ? null : this);
    }

}
